import { useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { GET_OPTION_ITEM } from '../graphql/product-queries'
import OptionItemForm from '../components/OptionItemForm'
import LoadingSpinner from '../components/LoadingSpinner'

const EditOptionItemPage = () => {
  const { id } = useParams<{ id: string }>()
  
  const { data, loading, error } = useQuery(GET_OPTION_ITEM, {
    variables: { id: parseInt(id!) },
    skip: !id
  })

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <div className="text-6xl mb-4">⚠️</div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">Error loading option item</h3>
        <p className="text-gray-500 mb-6">{error.message}</p>
      </div>
    )
  }

  if (!data?.optionItem) {
    return (
      <div className="text-center py-12">
        <div className="text-6xl mb-4">❓</div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">Option item not found</h3>
        <p className="text-gray-500 mb-6">The option item you're looking for doesn't exist.</p>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">Edit Option Item</h1>
        <p className="mt-1 text-sm text-gray-500">
          Update the option item settings below
        </p>
      </div>
      
      <OptionItemForm optionItem={data.optionItem} isEditing={true} />
    </div>
  )
}

export default EditOptionItemPage
